import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Subscription } from 'rxjs';
import { PATH } from './const/path';
import { NavbarComponent } from './core/navbar/navbar.component';
import { FlashMessageComponent } from './core/flash-message/flash-message.component';
import { HttpErrorComponent } from './core/http-error/http-error.component';
import { LoadingWidgetDirective } from './core/directives/loading-widget/loading-widget.directive';

@Component({
    selector: 'admin-layout',
    templateUrl: './layout.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterOutlet, NavbarComponent, FlashMessageComponent, HttpErrorComponent, LoadingWidgetDirective]
})
export class LayoutComponent implements OnInit, OnDestroy {

  shown = false;
  showNavigationBar = true;
  message: { [key: string]: string } = {};
  
  private readonly notification$: Subscription = new Subscription();

  ngOnInit(): void {
    const path = sessionStorage.getItem('adminUIPath');
    if (path?.includes(PATH.tasks)) {
      this.showNavigationBar = false;
    } else {
      this.showNavigationBar = true;
    }
  }

  ngOnDestroy() {
    this.notification$.unsubscribe();
  }

}
